<template>
  <div v-if="autoCampaign" class="medium-3 columns" id="settings-wrapper">
    <modal
        v-if="showMilestoneModal"
        wrapperClasses="milestone-modal">
        <h2 v-if="dateSelected" slot="header" class="title">setting a milestone start date</h2>
        <h2 v-else slot="header" class="title">setting a milestone to 'all time'</h2>

        <div slot="body" class="body">
          <p v-if="dateSelected">adding a milestone start date will only count transactions of members going forward from the defined start date. once a start date is defined, changing the milestone to “all time” may cause this autoconnect to send to members who have previously qualified in the past.</p>
          <p v-else>setting your milestone to “all time” will count transactions of members retroactively and apply them to the milestone. if a member has already achieved this milestone in the past, once enabled, the member will be sent this autoconnect on their next transaction</p>
        </div>

        <div
            slot="action"
            class="button larger modal-click-action"
            @click="showMilestoneModal = false">
          got it
        </div>
    </modal>

    <div class="data-description">configure autoconnect settings</div>
    <small class="error-label in-settings-title" v-if="apiError">{{apiError}}</small>
    <div id="mobile-wrapper">
      <label>status</label>
      <div id="switch-wrapper">
        <span>enabled</span>
        <span class="switch">
            <input name="auto_campaign[enabled]" type="hidden" value="0">
            <input id="enabled"
                   class="switch-input"
                   type="checkbox"
                   value="1"
                   name="auto_campaign[enabled]"
                   v-model="isEnabled"
                   @change="toggleEnable" />
            <label class="switch-paddle enable-button" for="enabled"></label>
          </span>
      </div>

      <label id="name-label" for="name">name ({{inputTitle}})</label>
      <input autofocus="autofocus"
             :class="['form-control', {['error-label']: errors.name}]"
             id="name"
             name="auto_campaign_name"
             type="text"
             v-model="nameValue"
             @blur="setInteractions('name')"
             @change="validateName" />
      <small class="error-label" v-if="errors.name">{{errors.name}}</small>

      <div v-if="settings" :class="['auto-campaign-settings', settings.type]">
        <label v-if="settings.inputItem && settings.inputItem.label"
               :for="settings.inputItem.for">{{settings.inputItem.label}}</label>
        <select-toggle-input v-if="settings.type === 'referral'"
                             :inputItem="settings.toggleInput"
                             :openToggleValue ="settings.openValue"
                             :selectBoxInput="settings.selectBox"
                             shouldSetInteractions
                             showErrors
                             zeroAllowed
                             @saveInputValue="updateSettings"
                             @setErrors="setErrors"
                             @setInteractions="setInteractions"></select-toggle-input>

        <toggle-radio-input v-if="settings.toggleRadio"
                            :inputId="settings.toggleRadio.inputId"
                            :radios="settings.toggleRadio.radios"
                            :savedInputValue="autoCampaign[settings.toggleRadio.inputId]"
                            :spanBeforeText="settings.toggleRadio.spanBeforeText"
                            :spanAfterText="settings.toggleRadio.spanAfterText"
                            :valueLabel="settings.toggleRadio.valueLabel"
                            @setErrors="setErrors"
                            @setInteractions="setInteractions"
                            @updateSettings="updateSettings"></toggle-radio-input>

        <input-item v-if="settings.inputItem"
                    :inputClass="settings.inputItem.class"
                    :inputId="settings.inputItem.for"
                    :inputType="settings.inputItem.inputType"
                    :inputValue="autoCampaign[settings.inputItem.for]"
                    :isCurrency="settings.inputItem.isCurrency"
                    :options="settings.inputItem.options"
                    :placeholder="settings.inputItem.placeHolder"
                    :step="settings.inputItem.inputStep"
                    :min="settings.inputItem.min"
                    :max="settings.inputItem.max"
                    shouldSetInteractions
                    showErrors
                    @setErrors="setErrors"
                    @saveInputValue="updateSettings"
                    @setInteractions="setInteractions"></input-item>

        <min-max-inputs v-if="settings.hasMinMax"
                        :maxInput="settings.maxInput"
                        :minInput="settings.minInput"
                        shouldSetInteractions
                        showErrors
                        @setErrors="setErrors"
                        @saveInputValue="updateSettings"
                        @setInteractions="setInteractions"></min-max-inputs>

        <send-time-input v-if="settings.setTime"
                         :sendAtLocal="autoCampaign.send_at_local"
                         @setErrors="setErrors"
                         @setInteractions="setInteractions"
                         @updateSettings="updateSettings"></send-time-input>
       <div v-if="settings.disclaimer" class="data-disclaimer">
         Disclaimer: {{settings.disclaimer}}
       </div>
        <add-configuration v-if="settings.hasAddConfiguration"
                           :shouldOpenOnCreate="!!autoCampaign.argument_2 || !!autoCampaign.argument_3">
          <div slot="configItems" class="config-items-slot">
            <input-item :inputClass="settings.timeframeInput.class"
                        :inputId="settings.timeframeInput.for"
                        :inputType="settings.timeframeInput.inputType"
                        :inputValue="autoCampaign[settings.timeframeInput.for]"
                        :labelText="settings.timeframeInput.label"
                        showErrors
                        @setErrors="setErrors"
                        @saveInputValue="updateSettings"
                        @setInteractions="setInteractions"></input-item>

            <input-item :inputClass="settings.circumventSelect.class"
                        :inputId="settings.circumventSelect.for"
                        :inputType="settings.circumventSelect.inputType"
                        :inputValue="circumventSelectValue"
                        :labelText="settings.circumventSelect.label"
                        :options="settings.circumventSelect.options"
                        showErrors
                        @setErrors="setErrors"
                        @saveInputValue="updateSettings"
                        @setInteractions="setInteractions"></input-item>

            <div  v-if="settings.type === 'spend-milestone'">
              <label class="milestone-label">milestone start date</label>
              <div class="milestone-tabs">
                <div @click="selectedMilestone('all')"
                      :class="['all', 'milestone', { selected: allSelected}]">all time</div>
                <div @click="selectedMilestone('date')"
                      :class="['date', 'milestone', { selected: dateSelected}]">date</div>
              </div>
            </div>

            <flat-pickr v-if="dateSelected"
                        name="date"
                        v-model="date"
                        :config="datePickerConfig"
                        @on-close="updateMilestoneDate"></flat-pickr>
          </div>
        </add-configuration>
      </div>
    </div>
  </div>
</template>


<script>
  import AddConfiguration from './AddConfiguration'
  import axiosConfig from '../../../packs/axios'
  import ConfigureSettings from '../../mixins/ConfigureSettingsMixin'
  import flatPickr from 'vue-flatpickr-component'
  import InputItem from '../FormItems/InputItem'
  import moment from 'moment'
  import MinMaxInputs from '../FormItems/MinMaxInputs'
  import Modal from '../../components/shared/Modal'
  import SelectToggleInput from '../FormItems/SelectToggleInput'
  import SendTimeInput from './SendTimeInput'
  import ToggleRadioInput from '../FormItems/ToggleRadioInput'

  export default {
    props: {
      allowEnable: Boolean,
      autoCampaignId: String,
      autoCampaignFromEdit: Object,
      otherErrors: Object,
      contactType: String,
    },

    name: 'Settings',

    components: {
      InputItem,
      AddConfiguration,
      MinMaxInputs,
      Modal,
      SelectToggleInput,
      SendTimeInput,
      ToggleRadioInput,
      flatPickr
    },

    mixins: [ConfigureSettings],

    data() {
      return {
        addConfiguration: false,
        apiError: null,
        allSelected: true,
        autoCampaign: null,
        datePickerConfig: {
          altFormat: 'Y-m-d',
          dateFormat: 'D, M d, Y'
        },
        date: null,
        dateSelected: false,
        inputTitle: this.contactType,
        errors: {},
        interactions: {
          name: true,
        },
        isEnabled: false,
        nameValue: null,
        showMilestoneModal: false
      }
    },

    methods: {
      disableIfError(dataToUpdate) {
        if (dataToUpdate.enabled) { this.isEnabled = false }
      },

      initInteractions() {
        if (this.settings) {
          if (this.settings.setTime) { this.interactions.time = !this.autoCampaign.send_at_local }
          if (this.settings.interactionsToSet) {
            this.settings.interactionsToSet.forEach((argItem) => {
              this.$set(this.interactions, argItem, !this.autoCampaign[argItem])
            })
          }
        }
      },

      initSettings() {
        this.nameValue = this.autoCampaign.name
        this.$set(this.interactions, 'name', !this.nameValue)
        this.configureSettings()
        this.initInteractions()
      },

      setErrors(errorsKey, errorMessage) {
        const errorItem = this.errors[errorsKey]
        if (errorMessage) {
          if (errorItem !== errorMessage || !errorItem) { this.$set(this.errors, errorsKey, errorMessage) }
        } else {
          if (errorItem) { this.$delete(this.errors, errorsKey) }
        }
      },

      setInteractions(settingKey, fromInput) {
        if (this.interactions[settingKey]) {
          this.$set(this.interactions, settingKey, false)
          if (settingKey === 'name' && !fromInput) { this.validateName(null, true) }
          this.updateInteractions()
        }
      },

      toggleEnable(event) {
        let shouldEnable = event ? event.target.checked : false
        if(typeof event === 'boolean') {
          this.isEnabled = event;
        }
        if (shouldEnable !== this.autoCampaign.enabled) { this.updateSettings({ enabled: shouldEnable }) }
      },

      updateInteractions() {
        const updateInteractions = Object.values(this.interactions).includes(true) ? { settings: true } : {}
        this.$store.dispatch('UPDATE_STATE_OBJECT', {
          stateKey: 'noUserInteractions',
          itemKey: 'settings',
          itemObject: updateInteractions
        })
      },

      updateMilestoneDate(date) {
        let stripTimeZone = moment(date[0]).format().split('T')
        this.updateSettings({ argument_4: stripTimeZone[0]})
      },

      updateSettings(dataToUpdate, isFromBlur) {
        if (!isFromBlur) {
          const url = `/api/v3/auto_campaigns/${this.autoCampaign.id}`,
            campaignData = { auto_campaign: dataToUpdate }
          axiosConfig.patch(url, campaignData)
            .then((response) => {
              const data = response?.data?.auto_campaign,
                errorMessage = response?.data?.error || response?.data?.errors?.reject_reason?.[0]
              if (data && !errorMessage) {
                this.autoCampaign = data
                this.$emit('setAutoCampaign', this.autoCampaign)
                this.apiError = null
              } else if (errorMessage) {
                this.apiError = `cannot update settings: ${errorMessage}`
                this.disableIfError(dataToUpdate)
              } else {
                this.apiError = 'issue encountered updating settings'
                this.disableIfError(dataToUpdate)
              }
            })
            .catch((error) => {
              this.apiError = `issue encountered updating settings: ${error}`
              this.disableIfError(dataToUpdate)
            })
        }
      },

      setTitle() {
        const walletTypes = ['email add', 'interests add', 'birthday add', 'spend milestone']
        this.inputTitle = walletTypes.includes(this.autoCampaign.header) ? 'will display on wallet' : 'for your reference'
      },

      validateName(event, isFromBlur) {
        this.setInteractions('name', true)
        const name = event?.currentTarget?.value || this.autoCampaign.name
        if (name) {
          this.$delete(this.errors, 'name')
          if (this.autoCampaign.name !== name) { this.updateSettings({ name: name }, isFromBlur) }
        } else {
          this.$set(this.errors, 'name', 'autoconnect must have a name')
        }
      },

      validateSettings(isValid) {
        const validObject = isValid ? {} : { settings: isValid }
        this.$store.dispatch('UPDATE_STATE_OBJECT', {itemKey: 'settings', itemObject: validObject})
      },

      selectedMilestone(milestone) {
        this.showMilestoneModal = true

        if (milestone === 'all') {
          this.updateSettings({ argument_4: 'all time' })
          this.allSelected = true
          this.dateSelected = false
        } else {
          this.dateSelected = true
          this.allSelected = false
        }
      },

      formatToDate(date) {
        this.date = moment(date).format('ddd, MMM Do, YYYY')
      }
    },

    created() {
      this.autoCampaign = this.autoCampaignFromEdit
      this.isEnabled = this.autoCampaign.enabled
      this.initSettings()
      this.updateInteractions()
      this.setTitle()

      if (this.autoCampaign?.argument_4 !== null) {
        this.formatToDate(this.autoCampaign.argument_4)
        this.dateSelected = true
        this.allSelected = false
      } else {
        this.allSelected = true
      }
    },

    computed: {
      circumventSelectValue: function() {
        if (this.settings?.hasAddConfiguration) {
          const selectValue = this.autoCampaign[this.settings.circumventSelect.for]
          return selectValue ? selectValue : ''
        }
      },
    },

    watch: {
      errors: function() {
        this.validateSettings(!Object.keys(this.errors).length)
      },
    },
  }
</script>
